import { classSet } from '@umu/umu-dom';
import React from 'react';

interface IProps {
    position?: {
        top?: string;
        right?: string;
        bottom?: string;
        left?: string;
    };
    className?: string;
    children: JSX.Element | JSX.Element[];
}

import './overSticky.scss';
export const OverSticky = (props: IProps) => {
    const { children, className, position = {} } = props;

    const cls = classSet({
        'over-sticky': true,
        'top': position.hasOwnProperty('top'),
        'right': position.hasOwnProperty('right'),
        'bottom': position.hasOwnProperty('bottom'),
        'left': position.hasOwnProperty('left'),
    });

    const getStyle = () => {
        const style: React.CSSProperties = {};
        if (position.hasOwnProperty('top')) {
            style.top = position.top;
        }
        if (position.hasOwnProperty('right')) {
            style.right = position.right;
        }
        if (position.hasOwnProperty('bottom')) {
            style.bottom = position.bottom;
        }
        if (position.hasOwnProperty('left')) {
            style.left = position.left;
        }
        return style;
    };
    return (
        <div className={`${className ? className : ''} ${cls}`} style={getStyle()}>
            {children}
        </div>
    );
};
